import React, { useMemo } from "react";
import { UserData } from "@/entities/users/types";
import { useReport } from "@/entities/reporting/hooks";
import { OverallScoringData, ReportType } from "@/entities/reporting/types";
import QuotaAchievement from "./QuotaAchievement";

interface Props {
  leadUser?: UserData;
}

const QuotaAchievementWrapper: React.FC<Props> = ({ leadUser }) => {
  const { report: overallReport, isLoading } = useReport(
    ReportType.QUOTA_ACHIEVEMENT
  );

  const overallData: OverallScoringData = useMemo(
    () => overallReport?.quotaAchievement?.overall ?? undefined,
    [overallReport]
  );

  const isArr: boolean = useMemo(
    () => overallReport?.quotaAchievement?.isArr ?? undefined,
    [overallReport]
  );

  const period = useMemo(
    () => overallReport?.quotaAchievement?.period,
    [overallReport]
  );

  return (
    <QuotaAchievement
      leadUser={leadUser}
      overallData={overallData}
      isArr={isArr}
      period={period}
      isLoading={isLoading}
    />
  );
};

export default QuotaAchievementWrapper;
